<template>
  <div class="tab-content-container">
    <!--    Notes    -->
    <div class="tab-header-container">
      <h2 class="form-label">Бележки</h2>
      <LiteButton @click.native="addNote"
                  class="edit-button"
                  :hoverColor="'green'"
                  :icon="'far fa-plus-square'">
      </LiteButton>
    </div>

    <hr class="form-line">

    <!-- One Note -->
    <div class="item-container very-light-shadow"
         style="padding-bottom: 0;"
         v-for="note in notes" :key="note.id">
      <LiteButton @click.native="editNote(note)"
                  class="edit-button"
                  :hoverColor="'blue'"
                  :icon="'far fa-edit'">
      </LiteButton>
      <div class="last-modified-container">
        <p class="last-modified-date" v-text="getLastModifiedDate(note)"></p>
        <p class="last-modified-name" v-text="getLastModifiedBy(note)"></p>
      </div>
      <div class="note-content-container">
        <p class="note-content-label">Съдържание:</p>
        <p class="note-content">{{ note.content }}</p>
      </div>
    </div>

    <!-- Edit/Add Note -->
    <WorkerNotesEditForm class="popup-shadow" v-if="shouldEdit" :note="currentEditNote" @close-clicked="closeEdit"/>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import mapperService from "@/services/mapper.service";
import LiteButton from "@/shared/components/button/LiteButton"
import WorkerNotesEditForm from "@/components/worker/form/WorkerNotesEditForm";
import {cloneDeep} from 'lodash';

export default {
  name: "WorkerNotes",
  components: {WorkerNotesEditForm, LiteButton},
  created() {
    this.notes = cloneDeep(this.workerNotes);
  },
  data() {
    return {
      workerId: this.$route.params.id,
      notes: cloneDeep(this.workerNotes),
      shouldEdit: false,
      currentEditNote: null
    }
  },
  methods: {
    getLastModifiedBy(contact) {
      return mapperService.getLastModifiedBy(contact);
    },
    getLastModifiedDate(contact) {
      return mapperService.getLastModifiedDate(contact);
    },
    addNote() {
      this.currentEditNote = {};
      this.currentEditNote.workerId = this.workerId;
      this.$store.commit('setHasModal', true);
      this.shouldEdit = true;
    },
    editNote(note) {
      this.currentEditNote = note;
      this.currentEditNote.workerId = this.workerId;
      this.$store.commit('setHasModal', true);
      this.shouldEdit = true;
    },
    closeEdit() {
      this.currentEditNote = null;
      this.$store.commit('setHasModal', false);
      this.shouldEdit = false;
    }
  },
  computed: {
    ...mapGetters(['workerNotes'])
  },
  watch: {
    workerNotes: {
      handler(newVal) {
        if (newVal) {
          this.notes = cloneDeep(newVal);
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
@import '../../../css/main/notes.css';
</style>
